import _extends from "@babel/runtime/helpers/extends";
import { getClientId } from "@smartsheet/lodestar-utils";
import React, { forwardRef } from "react";
import { useI18n } from "../../../../i18n/i18n";
import { useTheme } from "../../../../theme/utils/useTheme";
import { VisuallyHidden } from "../../../visuallyhidden";
import { ActionButton } from "../shared/ActionButton";
import { ToggleButtonIcon } from "./ToggleButtonIcon";
export const ToggleButton = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    clientId,
    hideDropdownArrow,
    isReadonly,
    isHovered,
    isActive,
    isOpen,
    ...rest
  } = _ref;
  const {
    i18n
  } = useI18n();
  const {
    key
  } = useTheme();
  const themeMode = key;
  const sharedProps = {
    ...rest,
    "aria-label": i18n._( /*i18n*/{
      comment: "This button opens and closes the select menu",
      id: "Toggle menu"
    }),
    ref
  };

  // If the button is readonly, we need to to still be there so we can interact with it.
  // However, we don't want it to be visible at all--same with hideDropdownArrow, by no coincidence.
  return isReadonly || hideDropdownArrow ? /*#__PURE__*/React.createElement(VisuallyHidden, _extends({
    renderAs: "button"
  }, sharedProps, {
    "aria-disabled": "true"
  }), null) : /*#__PURE__*/React.createElement(ActionButton, _extends({}, sharedProps, {
    // Pass isDisabled here for Clickable to update its state.
    isDisabled: isReadonly,
    omitFocusRing: true,
    isHovered: isHovered,
    isActive: isActive,
    isOpen: isOpen,
    clientId: getClientId(clientId, "-toggle"),
    themeMode: themeMode
  }), /*#__PURE__*/React.createElement(ToggleButtonIcon, null));
});
ToggleButton.displayName = "ToggleButton";
//# sourceMappingURL=ToggleButton.js.map